// extracted by mini-css-extract-plugin
export var closeButton = "_k6-1";
export var closeX = "_k6-3";
export var container = "_k6-0";
export var image = "_k6-2";